import { ComboBox } from "@progress/kendo-react-dropdowns";
import { useSelector } from "react-redux";
import { allDatasets } from "../../Common/Store/CommonSignals";

export function DatasetHelper(currentPropertyValues) {
  const dataset = useSelector(() => {
    return allDatasets.value.find((dataset) => dataset.id === currentPropertyValues?.Dataset?.id);
  });

  if (!dataset) {
    return [];
  }
  return dataset.values?.map((option) => option.value) || [];
}

function scrollToFilteredItem(filterText) {
  if (filterText === "") return;
  if (filterText === null) return;
  if (filterText === undefined) return;

  const popupRef = document.querySelector(".k-animation-container .k-list-container");
  const filteredItems = Array.from(popupRef.querySelectorAll(".k-list-item-text")).filter((item) =>
    item.innerText.toLowerCase()?.startsWith(filterText.toLowerCase())
  );

  if (filteredItems?.length > 0) {
    filteredItems[0].scrollIntoView({ block: "start" });
  } else {
    const options = Array.from(popupRef?.querySelectorAll(".k-list-item-text"));
    options?.[0].scrollIntoView({ block: "start" });
  }
}

export const DefaultListValueProperty = {
  propertyName: "DefaultValue",
  propertyDisplay: "Default Value",
  propertyType: "string",
  propertyCategory: "Data",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <ComboBox
        data={DatasetHelper(currentPropertyValues)}
        onChange={(e) => {
          handlePropertyChange({ propName: this.propertyName, propValue: e.target.value });
        }}
        defaultValue={currentPropertyValues?.[this.propertyName] || ""}
        filterable={true}
        onFilterChange={(e) => {
          setTimeout(() => {
            scrollToFilteredItem(e.filter.value);
          }, 0);
        }}
      />
    );
  },
};
